import { AxiosRequestConfig } from 'axios'
import { message } from 'ant-design-vue'
import _axios from './fetch'
import { HOST } from './url'

interface Response {
  code: number;
  msg: string;
  data: any;
}

interface RequestConfig extends AxiosRequestConfig {
  reportError?: boolean | ((res: Response) => boolean);
}

function request(config: RequestConfig) {
  return _axios({ ...config, baseURL: HOST }).then((data: any) => {
    if (!data || data instanceof Blob) return data
    if (data.code === 0) return data.data || data
    let { reportError } = config
    if (typeof reportError === 'function') {
      reportError = reportError(data)
    }
    reportError !== false && message.error(data.msg)
    return Promise.reject(data)
  })
}

request.get = (url: string, config?: AxiosRequestConfig) =>
  request({ ...config, url })

request.post = (url: string, data?: any, config?: AxiosRequestConfig) =>
  request({ ...config, method: 'POST', url, data })

export default request
